import PageContainer from 'layouts/PageContainer'
import TrimInfoList from './ui/TrimInfoList'

const TrimEditPage = () => {
	return (
		<PageContainer>
			<TrimInfoList />
		</PageContainer>
	)
}

export default TrimEditPage
